module.exports = __webpack_public_path__ + "img/744.91ea31b1.jpg";